import { ContentCopy, SupportAgentOutlined } from "@mui/icons-material";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Link,
  Tooltip,
  Typography,
} from "@mui/material";

import { AppLogo } from "~ui/organisms/AppLogo/AppLogo";

const tTechSupport = "Tech Support";
const tTechSupportClose = "Close";
const TECH_SUPPORT_EMAIL = "contact@crowdcoursing.com";
const tTechSupportIntro =
  "Questions or issues? Email us—we’re glad to help. Our support team is available Monday through Friday, 6:00 a.m. to 9:00 p.m. Eastern Time.";
const tCopyEmailTooltip = "Copy email address";

export interface VisitorManagementTechSupportDialogProps {
  logoHeight: string;
  onClose: () => void;
  open: boolean;
}

export function VisitorManagementTechSupportDialog({
  logoHeight,
  onClose,
  open,
}: VisitorManagementTechSupportDialogProps) {
  return (
    <Dialog fullWidth maxWidth="sm" open={open} onClose={onClose}>
      <DialogTitle sx={{ alignItems: "center", display: "flex", gap: 1 }}>
        <SupportAgentOutlined sx={{ color: "primary.main" }} />
        {tTechSupport}
      </DialogTitle>
      <DialogContent dividers>
        <Box
          sx={{
            alignItems: "center",
            display: "flex",
            flexDirection: "column",
            gap: 2.5,
            py: 1,
            textAlign: "center",
          }}
        >
          <AppLogo logo="navBarLogo" style={{ height: logoHeight }} />
          <Box sx={{ alignItems: "center", display: "flex", flexDirection: "row", gap: 0.5, justifyContent: "center" }}>
            <Link
              href={`mailto:${TECH_SUPPORT_EMAIL}`}
              sx={{
                "&:hover": {
                  textDecoration: "underline",
                },
                color: (theme) =>
                  theme.palette.mode === "dark" ? theme.palette.text.primary : theme.palette.common.black,
                fontSize: "1.125rem",
                fontWeight: 600,
                textDecoration: "none",
              }}
            >
              {TECH_SUPPORT_EMAIL}
            </Link>
            <Tooltip title={tCopyEmailTooltip}>
              <IconButton
                aria-label={tCopyEmailTooltip}
                edge="end"
                size="small"
                sx={{
                  color: (theme) =>
                    theme.palette.mode === "dark" ? theme.palette.text.primary : theme.palette.common.black,
                }}
                onClick={() => {
                  void navigator.clipboard.writeText(TECH_SUPPORT_EMAIL);
                }}
              >
                <ContentCopy fontSize="small" />
              </IconButton>
            </Tooltip>
          </Box>
          <Typography color="text.secondary" variant="body1">
            {tTechSupportIntro}
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions sx={{ px: 3, py: 2 }}>
        <Button variant="contained" onClick={onClose}>
          {tTechSupportClose}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
